import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';
import { FormField } from 'components/FormHelper/FormField';

import './Popup.sass';

export const SealsPopup = ({ oldData, formik, selectedRow, popupOpen, setPopupOpen }) => {
  const lostDateFieldName = `seals[${selectedRow}].lostDate`;
  const lostReasonFieldName = `seals[${selectedRow}].lostReason`;

  const modalContent = () => {
    if (formik.values.seals && formik.values.seals[`${selectedRow}`])
      return (
        <div className="popup-content">
          <div className="popup-content__popup-subtext">
            Möchten Sie Plombierausrüstung {formik.values.seals[`${selectedRow}`].sealNumber}{' '}
            ausgegeben am {formik.values.seals[`${selectedRow}`].issuedOn} als verloren melden?
          </div>
          <div className="popup-content__popup-field">
            <FormField
              name={lostDateFieldName}
              formik={formik}
              label="Verloren am*"
              oldValue=""
              fullWidth
              error={Boolean(
                formik.errors.seals ? formik.errors.seals[`${selectedRow}`]?.lostDate : ''
              )}
              helperText={
                formik.errors.seals ? formik.errors.seals[`${selectedRow}`]?.lostDate : ''
              }
            />
          </div>
          <div className="popup-content__popup-field">
            <FormField
              name={lostReasonFieldName}
              formik={formik}
              label="Grund"
              oldValue=""
              fullWidth
              error={Boolean(
                formik.errors.seals ? formik.errors.seals[`${selectedRow}`]?.lostReason : ''
              )}
              helperText={
                formik.errors.seals ? formik.errors.seals[`${selectedRow}`]?.lostReason : ''
              }
            />
          </div>
        </div>
      );

    return null;
  };

  return (
    <CustomModal
      isOpen={popupOpen}
      title="Verlustmeldung Plombierausrüstung"
      ctaButtons={
        <>
          <ActionButton
            onClick={() => {
              if (!formik.errors.seals) setPopupOpen(false);
            }}
            title="Ok"
          />
          <ActionButton
            inverted
            onClick={() => {
              formik.setFieldValue(`seals[${selectedRow}]`, oldData[selectedRow]);
              setPopupOpen(false);
            }}
            title="Abbrechen"
          />
        </>
      }
      content={modalContent()}
    />
  );
};
SealsPopup.propTypes = {
  oldData: PropTypes.array,
  formik: PropTypes.object,
  selectedRow: PropTypes.number,
  popupOpen: PropTypes.bool,
  setPopupOpen: PropTypes.func,
};
SealsPopup.defaultProps = {
  oldData: [],
  formik: {},
  selectedRow: 0,
  popupOpen: false,
  setPopupOpen: () => {},
};
